import { inject, Injectable, signal, Signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EdsTranslationService, TranslationParams } from '@eventim/eds2/i18n';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomTranslationProxyService extends EdsTranslationService {
  locale: Signal<string>;

  private readonly _locale = signal<string>(localStorage.getItem('locale') ?? 'fr-FR');
  private readonly ngxTranslateService = inject(TranslateService);

  constructor() {
    super();
    this.locale = this._locale.asReadonly();
    this.ngxTranslateService.use(this.locale());

    this.ngxTranslateService.onLangChange.pipe(takeUntilDestroyed()).subscribe(({ lang }) => {
      this._locale.set(lang);
    });
  }

  setLocale(locale: string): void {
    this.ngxTranslateService.use(locale);
    localStorage.setItem('locale', locale);
  }

  translate(key: string, params?: TranslationParams): string {
    return this.ngxTranslateService.instant(key, params) ?? this.translate(key, params) ?? key;
  }
}
